import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const WorkEnvironmentTemplatesQueryKey = 'WORK_ENVIRONMENT_TEMPLATES';

export const useGetWorkEnvironmentTemplatesQuery = (
  enabled: boolean = true,
) => {
  const { getAllWorkEnvironmentTemplates } = useServicesContext();
  return useQuery({
    queryKey: [WorkEnvironmentTemplatesQueryKey],
    queryFn: () => getAllWorkEnvironmentTemplates(),
    enabled,
  });
};
